/** Safe localStorage accessor — returns null when unavailable (SSR, private mode, blocked). */
export function safeLocal(): Storage | null {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
}
